import React from 'react';
import { motion } from 'framer-motion';
import { InfoIcon } from 'lucide-react';
interface DescriptionPanelProps {
  title: string;
  description: string;
  insights?: string[];
}
const DescriptionPanel: React.FC<DescriptionPanelProps> = ({
  title,
  description,
  insights = []
}) => {
  return <motion.div initial={{
    opacity: 0,
    x: -20
  }} animate={{
    opacity: 1,
    x: 0
  }} transition={{
    duration: 0.5,
    ease: 'easeOut'
  }} className="bg-gradient-to-br from-blue-50 to-indigo-50 border-l-4 border-blue-600 rounded-xl p-6 shadow-sm mb-8" data-id="element-11686">
      <div className="flex items-start mb-4" data-id="element-11687">
        <div className="bg-blue-600 text-white p-2 rounded-lg mr-3" data-id="element-11688">
          <InfoIcon size={20} data-id="element-11689" />
        </div>
        <div className="flex-1" data-id="element-11690">
          <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-11691">{title}</h3>
          <p className="text-sm text-gray-700 leading-relaxed" data-id="element-11692">{description}</p>
        </div>
      </div>
      {insights.length > 0 && <div className="mt-4 pt-4 border-t border-blue-200" data-id="element-11693">
          <div className="text-xs font-semibold text-gray-600 uppercase tracking-wide mb-2" data-id="element-11694">
            Key Insights
          </div>
          <ul className="space-y-2" data-id="element-11695">
            {insights.map((insight, index) => <li key={index} className="flex items-start text-sm text-gray-700" data-id="element-11696">
                <span className="text-blue-600 mr-2 font-bold" data-id="element-11697">•</span>
                <span data-id="element-11698">{insight}</span>
              </li>)}
          </ul>
        </div>}
    </motion.div>;
};
export default DescriptionPanel;